import * as Yup from "yup";
import dayjs from "dayjs";

import {
    validationSchema as adjustmentValidationSchema,
    validationRowSchema as adjustmentValidationRowSchema,
    initialValues as adjustmentInitialValues,
    initialRowValues as adjustmentInitialRowValues
} from "./adjustmentSchema";

export const validateRowSchema = Yup.object().shape({
    name: Yup
        .string()
        .required("Required"),
    description: Yup
        .string()
        .required("Required"),
    qty: Yup
        .number()
        .typeError("NUmber Only")
        .required("Required")
        .test(
            "is-positive",
            "Please enter a positive number",
            (value) => value >= 0 && 1 / value !== -Infinity),
    // price: Yup
    //     .number("Invalid decimal")
    //     .positive()
    //     .required("Required")
})

export const validationSchema = Yup.object({
    // discount: Yup
    //     .string()
    //     .required('Required'),
    // description: yup
    //     .string()
    //     .required('Description is required'), 
    documentDate: Yup
        // .string()
        .date("Invalid")
        .required("Required")
        .typeError("Invalid"),
    locationId: Yup
        .string()
        .required("Required"),
    rows: Yup.array().of(validateRowSchema),
    adjustments: adjustmentValidationSchema,

})

export const initialRowValues = {
    docItemId: 0,
    name: "",
    decription: "",
    qty: "",
    // price: "",
    // subtotal: "0.00"
}

export const initialValues = {
    documentDate: dayjs(),
    rows: [initialRowValues],
    totalqty: "0",
    locationId: "",
    locationName: ""
    // discount: "0.00",
    // totalamount: "0.00"
    // name: ["aa", "bbb"]
    // docDate: "",
    // description: "",
    // status: true,
}
